<script setup>
import {useSlots} from 'vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  card: {
    type: Boolean,
    default: false,
  },
  headerAlign: {
    type: String,
    default: 'center',
  },
  fullWidth: {
    type: Boolean,
    default: false,
  }
})

const slots = useSlots()
</script>

<template>
  <div class="section" :class="{'section__content--bg': slots?.image}">
    <div class="section__bg" v-if="slots?.image">
      <slot name="image" />
    </div>

    <div class="section__content" :class="{'section__content--card': card, 'section--full-width': fullWidth}">
      <div
          v-if="title || description || slots?.title || slots?.description"
          class="section__heading"
          :class="`text-${headerAlign}`">
        <div class="section__title" v-if="title || slots?.title">
          <slot name="title">{{ title }}</slot>
        </div>
        <div class="section__description">
          <slot name="description">{{ description }}</slot>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.section {
  position: relative;
  padding: 40px 16px;

  @media screen and (min-width: 768px) {
    padding: 80px 0;
  }

  &.section__content--bg .section__bg :deep(img) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    display: block;
    object-fit: cover;
  }

  .section__content {
    z-index: 2;
    position: relative;

    &:not(.section--full-width) {
      max-width: 1080px;
      margin: 0 auto;
    }

    @media screen and (max-width: 1068px) {
      margin: 2rem;
    }

    &.section__content--card {
      border-radius: 16px;
      background: var(--shades-white, #FFF);
      box-shadow: 0 4px 6px -4px rgba(16, 24, 40, 0.10), 0px 10px 15px -3px rgba(16, 24, 40, 0.10);
      color: var(--primary-600, #183D4F);
      text-align: center;
      padding: 48px 24px;

      @media screen and (min-width: 768px) {
        padding: 96px 64px;
      }
    }

    .section__heading {
      margin-bottom: 32px;

      .section__title {
        font-family: Outfit, 'Outfit Fallback', Arial, serif;
        font-weight: 700;
        color: var(--primary-600, #183D4F);
        font-size: 32px;
        line-height: 44px;
        margin-top: 0;
        margin-bottom: 8px;

        @media screen and (min-width: 768px) {
          font-size: 40px;
          line-height: 48px;
        }
      }

      .section__description {
        @media screen and (min-width: 768px) {
          font-size: 18px;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
